import { render, staticRenderFns } from "./RegistroConsumos.vue?vue&type=template&id=0df3bead&"
import script from "./RegistroConsumos.vue?vue&type=script&lang=js&"
export * from "./RegistroConsumos.vue?vue&type=script&lang=js&"
import style0 from "./RegistroConsumos.vue?vue&type=style&index=0&id=0df3bead&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports